import * as React from "react";
import { FormattedMessage, MessageDescriptor } from "react-intl";
import { connect } from "react-redux";
import { CancelButton } from "../../views/common-forms/components";
import { validatePersonnummer } from "../../views/common/legal";
import { cancel, pushMessage } from "../../shared/timeclock/actions";
import * as api from "../../shared/timeclock/services/api";

import { CostDivisionList, Numpad } from "../components";
import { SelfRegistration as Messages } from "../messages";
import { StampCostDivision } from "../../shared/timeclock/models";
import { selfRegistrationComplete } from "../actions";
import { Action, Dispatch } from "redux";

interface SelfRegistrationProps {
    dispatch?: Dispatch<Action, unknown>;
}

interface SelfRegistrationState {
    personNo?: string;
    phone?: string;
    costDivisionRef?: number;
    availableCostDivs?: StampCostDivision[];
}

interface NumpadDisplayProps {
    hint: MessageDescriptor;
    onComplete: (label: string) => void;
    onBack: () => void;
    digits: number;
}

export const NumpadDisplay = ({ hint, onComplete, onBack, digits }: NumpadDisplayProps): JSX.Element => {
    return (
        <div className="self-registration">
            <h1><FormattedMessage {...Messages.Title} /></h1>
            <Numpad autoComplete={digits} onNumberCompleted={onComplete} hintMessage={hint} />
            <CancelButton onClick={onBack} />
        </div>
    );
};

const connector = connect();
class _SelfRegistration extends React.Component<SelfRegistrationProps, SelfRegistrationState> {
    state = {
        personNo: null,
        phone: null,
        costDivisionRef: null,
        availableCostDivs: null
    };

    componentDidMount() {
        api.selfRegisterCostDivisions().then((availableCostDivs) => this.setState({ availableCostDivs }));

        const systemMessage = { ...Messages.WelcomeText };
        this.props.dispatch(pushMessage({ systemMessage }));
    }

    back = () => this.props.dispatch(cancel());

    personNoComplete = (personNo: string) => {
        if (validatePersonnummer(personNo) && personNo.length == 12) {
            this.setState({ personNo });
        } else {
            const systemMessage = { ...Messages.BadPersonNo, values: { personNo } };
            this.props.dispatch(pushMessage({ systemMessage }));
            this.props.dispatch(cancel());
        }
    };

    phoneComplete = (phone) => this.setState({ phone });

    setCostDiv = (costDivisionRef) => {
        const request: api.SelfRegistrationRequest = { personNo: this.state.personNo, phone: this.state.phone, costDivisionRef };
        this.props.dispatch(selfRegistrationComplete(request));
    };

    render() {
        const { personNo, phone } = this.state;

        if (!this.state || !personNo) {
            return <NumpadDisplay hint={Messages.Step1EnterPersonNo} digits={12} onComplete={this.personNoComplete} onBack={this.back} />;
        } else if (!phone) {
            return <NumpadDisplay hint={Messages.Step2EnterPhone} digits={20} onComplete={this.phoneComplete} onBack={this.back} />;
        } else {
            return (
                <CostDivisionList
                    customTitle={Messages.Step3SelectCostDiv}
                    costDivisions={this.state.availableCostDivs}
                    onSelect={this.setCostDiv}
                    onBackClick={this.back}
                />
            );
        }
    }
}

export const SelfRegistration = connector(_SelfRegistration);
